import koCommon from './ko/common';
import koHome from './ko/home';
import koAbout from './ko/about';
import koBusiness from './ko/business';
import koProducts from './ko/products';
import koTechnical from './ko/technical';
import koSupport from './ko/support';
import koContact from './ko/contact';
import koQuotation from './ko/quotation';

import enCommon from './en/common';
import enHome from './en/home';
import enAbout from './en/about';
import enBusiness from './en/business';
import enProducts from './en/products';
import enTechnical from './en/technical';
import enSupport from './en/support';
import enContact from './en/contact';
import enQuotation from './en/quotation';

const messages = {
  ko: {
    translation: {
      notFound: koCommon.notFound,
      comingSoon: koCommon.comingSoon,
      common: {
        site: koCommon.site,
        nav: koCommon.nav,
        topbar: koCommon.topbar,
        footer: koCommon.footer,
      },
      home: koHome,
      about: koAbout,
      business: koBusiness,
      products: koProducts,
      technical: koTechnical,
      support: koSupport,
      contact: koContact,
      quotation: koQuotation,
    },
  },
  en: {
    translation: {
      notFound: enCommon.notFound,
      comingSoon: enCommon.comingSoon,
      common: {
        site: enCommon.site,
        nav: enCommon.nav,
        topbar: enCommon.topbar,
        footer: enCommon.footer,
      },
      home: enHome,
      about: enAbout,
      business: enBusiness,
      products: enProducts,
      technical: enTechnical,
      support: enSupport,
      contact: enContact,
      quotation: enQuotation,
    },
  },
};

export default messages;